import * as ActionTypes from 'constants';

export const canvassing = (state = {
  canvassing: false,
  markers: [],
  filters: [],
  size: 5000,
  total: 0,
  offset: 0,
  marker_types_initialized: false,
  fetching_markers: false,
  creating_marker: false,
  updating_marker: false,
  deleting_marker: false,
  show_marker_settings : false,
  marker_types : [],
  filtered_marker_types: [],
  show_create_new_marker_modal : false,
  show_edit_marker_modal : false
}, action) => {
  const { type, payload } = action;

  if(!state.canvassing && type != ActionTypes.TOGGLE_CANVASSING && type != ActionTypes.SET_MARKER_TYPES) {
    return { ...state, markers: [] };
  }

  switch(type) {
    case ActionTypes.FETCH_MARKERS:
      return {...state, fetching_markers : true};
    case ActionTypes.FETCH_MARKERS_SUCCESS:
      return {
        ...state,
        markers: payload.results,
        size: payload.size,
        total: payload.total,
        offset: payload.offset,
        fetching_markers: false
      }
    case ActionTypes.TOGGLE_CANVASSING:
      return {
        ...state,
        markers: [],
        canvassing: payload.canvassing,
      }
    case ActionTypes.CREATE_MARKER:
      return {
        ...state,
        creating_marker: true,
      }
    case ActionTypes.UPDATE_MARKER:
      return {
        ...state,
        updating_marker: true,
      }
    case ActionTypes.DELETE_MARKER:
      return {
        ...state,
        deleting_marker: true
      }
    case ActionTypes.CREATE_MARKER_SUCCESS:
      return {
        ...state,
        creating_marker: false,
        markers: [...state.markers, payload.marker],
      }
    case ActionTypes.DELETE_MARKER_SUCCESS:
      return {
        ...state,
        deleting_marker: false,
        markers: [...state.markers.filter(({_id}) => _id != payload.marker._id)]
      }
    case ActionTypes.UPDATE_MARKER_SUCCESS:
      let index = state.markers.findIndex(({_id}) => _id == payload.marker._id);
      return {
        ...state,
        updating_marker: false,
        markers: [
          ...state.markers.slice(0,index),
          payload.marker,
          ...state.markers.slice(index+1, state.markers.length)
        ]
      }
    case ActionTypes.CREATE_MARKER_FAILED:
      return {
        ...state,
        creating_marker: false,
      }
    case ActionTypes.DELETE_MARKER_FAILED:
      return {
        ...state,
        deleting_marker: false,
      }
    case ActionTypes.UPDATE_MARKER_FAILED:
      return {
        ...state,
        updating_marker: false,
      }
    case ActionTypes.TOGGLE_SHOW_MARKER_SETTINGS :
      return {...state, show_marker_settings : payload !== undefined ? payload : !state.show_marker_settings}
    case ActionTypes.SET_MARKER_TYPES :
      return {...state, marker_types : payload}
    case ActionTypes.SET_MARKER_SUCCESS :
      let {old_key} = payload.marker;
      delete payload.marker.old_key;
      let found_marker = state.marker_types.find(mt => mt.key == old_key)
      if(found_marker) {
        return {...state, marker_types : state.marker_types.map(mt => mt.key == old_key ? payload.marker : mt)}
      }
      else {
        return {...state, marker_types : [...state.marker_types, payload.marker]}
      }
    case ActionTypes.UPDATE_MARKER_NAME_SUCCESS :
      return {...state, marker_types : state.marker_types.map(mt => mt.key == payload.marker.key ? {...mt, name : payload.marker.name} : mt)}
    case ActionTypes.TOGGLE_SHOW_CREATE_NEW_MARKER_MODAL :
      return {...state, show_create_new_marker_modal : payload !== undefined ? payload : !state.show_create_new_marker_modal}
    case ActionTypes.TOGGLE_SHOW_EDIT_MARKER_MODAL :
      return {...state, show_edit_marker_modal : payload !== undefined ? payload : !state.show_edit_marker_modal}
    case ActionTypes.UNSET_MARKER_SUCCESS :
      let {key} = payload.marker;
      return {...state, marker_types : state.marker_types.filter(mt => mt.key != key)}
    case ActionTypes.TOGGLE_MARKER_TYPES_INITIALIZED:
      return { ...state, marker_types_initialized: payload != null ? payload : !state.marker_types_initialized };
    case ActionTypes.UPDATE_MARKER_FILTERS:
      return { ...state, filtered_marker_types: payload };
    case ActionTypes.UPDATE_MARKER_FILTER_USER:
      return { ...state, filter_user: payload }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/canvassing.js